import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitDevis = (data) => axios.post(`${API}/devis`, data);
export const submitContact = (data) => axios.post(`${API}/contact`, data);
